<template>
  <v-row>
    <v-row>
      <v-col class="align-left">
        <ExpandCollapseToggle
          id="schedulePanelToggle"
          @toggleAllPanels="toggleAllPanels"
          styleClass="mt-3"
          :panel="panel"
        />
      </v-col>
      <v-col class="align-right mt-2">
        <ValidationCountsHeader v-if="moduleType == MODULE_TYPES.MANAGEMENT" />
      </v-col>
    </v-row>

    <v-col sm="12" md="12" lg="12" xl="12" class="pa-0">
      <v-form v-model="schedulePageValid" ref="modifyInspectionScheduleForm">
        <v-expansion-panels v-model="panel" multiple color="#fff">
          <v-expansion-panel style="margin-top: 20px">
            <v-expansion-panel-title
              class="d-flex justify-start"
              hide-actions
              expand-icon="fa-solid fa-plus"
              collapse-icon="fa-solid fa-minus"
            >
              <v-icon v-if="!panel.includes(0)" icon="fa-solid fa-plus" />
              <v-icon v-if="panel.includes(0)" icon="fa-solid fa-minus" />
              <h3>SNBI Inspection Types Performed</h3>
            </v-expansion-panel-title>
            <v-expansion-panel-text eager>
              <v-row>
                <v-col class="px-0">
                  <v-btn
                    :disabled="!isEditable || anyEditable || isAccepted"
                    :id="`btn_add_insp_type`"
                    variant="outlined"
                    class="my-2 ml-1"
                    @click="addInspType"
                    >Add Inspection Type</v-btn
                  >
                </v-col>
              </v-row>
              <v-row class="mb-8">
                <v-col cols="12">
                  <v-data-table
                    id="inspectionTypes-data-table"
                    v-model:expanded="expandedRows"
                    :items-per-page="-1"
                    :headers="inspTypeHeaders"
                    :items="inspectionTypes"
                    class="compactTable lessPaddingTableColumns"
                    v-model:sort-by="sortBy"
                    hide-default-footer
                    must-sort
                    show-expand
                    return-object
                  >
                    <template v-slot:[`header.data-table-expand`]="{ column }">
                      {{ column.title }}
                    </template>
                    <template v-slot:[`header.inspType`]="{ column }">
                      <DataTableHeader :column="column" :sortBy="sortBy" />
                    </template>
                    <template v-slot:[`header.startDate`]="{ column }">
                      <DataTableHeader :column="column" :sortBy="sortBy" />
                    </template>
                    <template v-slot:[`header.endDate`]="{ column }">
                      <DataTableHeader :column="column" :sortBy="sortBy" />
                    </template>
                    <template v-slot:[`header.teamLeader`]="{ column }">
                      <DataTableHeader :column="column" :sortBy="sortBy" />
                    </template>
                    <template v-slot:[`header.inspInterval`]="{ column }">
                      <DataTableHeader :column="column" :sortBy="sortBy" />
                    </template>
                    <template v-slot:[`header.dueDate`]="{ column }">
                      <DataTableHeader :column="column" :sortBy="sortBy" />
                    </template>
                    <template v-slot:[`header.rbm`]="{ column }">
                      <DataTableHeader :column="column" :sortBy="sortBy" />
                    </template>
                    <template v-if="isEditable" v-slot:[`header.action`]="{ column }">
                      <DataTableHeader :column="column" :sortBy="sortBy" />
                    </template>
                    <template v-slot:item="{ item }">
                      <tr>
                        <td :class="rowClass(item) + ' align-center'">
                          <template v-if="expandedRows?.length == 0 || !anyEditable">
                            <button
                              v-if="!expandedRows.includes(item)"
                              @click="toggleRow(item)"
                              aria-label="toggleRowButtonOpen"
                            >
                              <v-icon
                                :id="`icon_Chevron_Right_${item.inspType}`"
                                icon="fa-solid fa-chevron-right"
                              ></v-icon>
                            </button>

                            <button
                              v-if="expandedRows.includes(item)"
                              @click="toggleRow(item)"
                              aria-label="toggleRowButtonClosed"
                            >
                              <v-icon
                                :id="`icon_Chevron_Down_${item.inspType}`"
                                icon="fa-solid fa-chevron-down"
                              ></v-icon>
                            </button>
                          </template>
                        </td>
                        <td :class="rowClass(item) + ' align-center'">
                          {{
                            item.inspType
                              ? configStore.getReferenceValue(REFERENCE_TABLE.SNBI_INSPECTION_TYPE, item.inspType)
                              : ""
                          }}
                        </td>
                        <td :class="rowClass(item) + ' align-center'">
                          {{ getFormattedDateStringNoTime(item.startDate) }}
                        </td>
                        <td :class="rowClass(item) + ' align-center'">
                          {{ getFormattedDateStringNoTime(item.endDate) }}
                        </td>
                        <td :class="rowClass(item) + ' align-center'">
                          {{
                            item.teamLeader
                              ? getTeamLeaders(item.inspType == INSPECTION_TYPE_PERFORMED.NSTM).find(
                                  (t) => t.value == item.teamLeader,
                                )?.title
                              : ""
                          }}
                        </td>
                        <td :class="rowClass(item) + ' align-center'">
                          {{ !["Z", "1", "5", "9", "P", "Q"].includes(item.inspType) ? item.inspInterval : "" }}
                        </td>
                        <td :class="rowClass(item) + ' align-center'">
                          {{ getFormattedDateStringNoTime(item.dueDate) }}
                        </td>
                        <td :class="rowClass(item) + ' align-center'">
                          {{ item.rbm ? configStore.getReferenceValue(REFERENCE_TABLE.RBI_METHOD, item.rbm) : "" }}
                        </td>
                        <td :class="rowClass(item) + ' align-center'" v-if="isEditable">
                          <div style="white-space: nowrap" v-if="isExpanded(item) && anyEditable && isEditable">
                            <IconTooltip
                              id="icon_add"
                              icon="fa-solid fa-check"
                              :tooltip="item.isAdd ? 'Add' : 'Update'"
                              @click="saveInspType(item)"
                            />
                            <IconTooltip
                              id="icon_close"
                              icon="fa-solid fa-xmark"
                              tooltip="Close"
                              @click="closeInspType"
                            />
                          </div>
                          <div
                            style="white-space: nowrap"
                            v-else-if="isEditable && (expandedRows?.length == 0 || !anyEditable)"
                          >
                            <IconTooltip
                              v-if="
                                !isAccepted ||
                                (hasAccesstoEditSnbiInspectionTypes && moduleType == MODULE_TYPES.MANAGEMENT)
                              "
                              id="icon_edit"
                              icon="fa-solid fa-pencil"
                              tooltip="Edit"
                              @click="editInspType(item)"
                            />
                            <IconTooltip
                              v-if="!isAccepted"
                              id="icon_delete"
                              icon="fa-solid fa-trash"
                              tooltip="Delete"
                              @click="deleteInspType(item)"
                            />
                          </div>
                        </td></tr
                    ></template>
                    <template v-slot:expanded-row="{ item }">
                      <td :colspan="inspTypeHeaders.length">
                        <v-form
                          ref="inspTypeDetailForm"
                          v-model="validDetails"
                          class="mt-2"
                          @change="changesDetected = true"
                        >
                          <v-row>
                            <v-col xl="6" lg="6" class="px-0">
                              <LabelSelect
                                labelXl="6"
                                labelLg="6"
                                labelMd="6"
                                labelSm="6"
                                selectXl="6"
                                selectLg="6"
                                selectMd="6"
                                selectSm="6"
                                id="inspectionType"
                                label="B.IE.01 Inspection Type"
                                :options="getAvailableSnbiTypes()"
                                :refTable="REFERENCE_TABLE.SNBI_INSPECTION_TYPE"
                                :isEditable="isEditable && !item.readOnly && item.isAdd && !isAccepted"
                                :isRequired="isEditable && !item.readOnly"
                                v-model="item.inspType"
                                @update:modelValue="setInspTypeFieldDependencies(item)"
                              ></LabelSelect>
                              <LabelDatefield
                                labelXl="6"
                                labelLg="6"
                                labelMd="6"
                                labelSm="6"
                                textXl="6"
                                textLg="6"
                                textMd="6"
                                textSm="6"
                                id="txt_snbi_start_date"
                                label="B.IE.02 Inspection Start Date"
                                v-model="item.startDate"
                                :isEditable="isEditable && !item.readOnly && !isAccepted"
                                :isRequired="isEditable && !item.readOnly"
                                @update:modelValue="updateEndDate(item)"
                              >
                              </LabelDatefield>
                              <LabelDatefield
                                labelXl="6"
                                labelLg="6"
                                labelMd="6"
                                labelSm="6"
                                textXl="6"
                                textLg="6"
                                textMd="6"
                                textSm="6"
                                id="txt_snbi_end_date"
                                label="B.IE.03 Inspection End Date"
                                v-model="item.endDate"
                                :isEditable="isEditable && !item.readOnly && !isAccepted"
                                @update:modelValue="setInspTypeDueDate(item)"
                                :minDate="item.startDate ? new Date(item.startDate) : new Date()"
                              >
                              </LabelDatefield>
                              <LabelSelect
                                labelXl="6"
                                labelLg="6"
                                labelMd="6"
                                labelSm="6"
                                selectXl="6"
                                selectLg="6"
                                selectMd="6"
                                selectSm="6"
                                id="select_snbi_teamleader"
                                label="B.IE.04 NCBI (Team Leader)"
                                :options="getTeamLeaders(item.inspType == INSPECTION_TYPE_PERFORMED.NSTM)"
                                :isEditable="isEditable && !item.readOnly && !isAccepted"
                                :isRequired="isEditable && !item.readOnly"
                                v-model="item.teamLeader"
                                @update:modelValue="setInspectorId(item)"
                              ></LabelSelect>
                              <LabelText
                                labelXl="6"
                                labelLg="6"
                                labelMd="6"
                                labelSm="6"
                                textXl="6"
                                textLg="6"
                                textMd="6"
                                textSm="6"
                                v-if="moduleType == MODULE_TYPES.MANAGEMENT"
                                id="txt_inspector_id"
                                label="B.IE.04a NCBI Number"
                                :modelValue="item.inspectorId"
                                :readOnly="true"
                              ></LabelText>
                              <LabelText
                                labelXl="6"
                                labelLg="6"
                                labelMd="6"
                                labelSm="6"
                                textXl="6"
                                textLg="6"
                                textMd="6"
                                textSm="6"
                                id="txt_snbi_interval"
                                label="B.IE.05 Inspection Interval"
                                v-model="item.inspInterval"
                                type="number"
                                :maxlength="2"
                                appendWith=" mos"
                              ></LabelText>
                              <LabelDatefield
                                labelXl="6"
                                labelLg="6"
                                labelMd="6"
                                labelSm="6"
                                textXl="6"
                                textLg="6"
                                textMd="6"
                                textSm="6"
                                id="txt_snbi_due_date"
                                label="B.IE.06 Inspection Due Date"
                                v-model="item.dueDate"
                              >
                              </LabelDatefield>
                              <LabelSelect
                                labelXl="6"
                                labelLg="6"
                                labelMd="6"
                                labelSm="6"
                                selectXl="6"
                                selectLg="6"
                                selectMd="6"
                                selectSm="6"
                                id="select_snbi_rbi"
                                label="B.IE.07 RBI Method"
                                :refTable="REFERENCE_TABLE.RBI_METHOD"
                                v-model="item.rbm"
                              ></LabelSelect>
                            </v-col>
                            <v-col xl="6" lg="6" class="px-0">
                              <LabelDatefield
                                labelXl="6"
                                labelLg="6"
                                labelMd="6"
                                labelSm="6"
                                textXl="6"
                                textLg="6"
                                textMd="6"
                                textSm="6"
                                id="txt_snbi_quality_control_date"
                                label="B.IE.08 Quality Control Date"
                                v-model="item.qcDate"
                              >
                              </LabelDatefield>
                              <LabelDatefield
                                labelXl="6"
                                labelLg="6"
                                labelMd="6"
                                labelSm="6"
                                textXl="6"
                                textLg="6"
                                textMd="6"
                                textSm="6"
                                id="txt_snbi_quality_assurance_date"
                                label="B.IE.09 Quality Assurance Date"
                                v-model="item.qaDate"
                                :isEditable="
                                  ((isEditable && !isAccepted) ||
                                    (hasAccesstoEditSnbiInspectionTypes && moduleType == MODULE_TYPES.MANAGEMENT)) &&
                                  !item.readOnly
                                "
                                @update:modelValue="changesDetected = true"
                              >
                              </LabelDatefield>
                              <LabelDatefield
                                labelXl="6"
                                labelLg="6"
                                labelMd="6"
                                labelSm="6"
                                textXl="6"
                                textLg="6"
                                textMd="6"
                                textSm="6"
                                id="txt_snbi_modified_date"
                                label="B.IE.10 Modified Date"
                                :showTime="true"
                                v-model="item.inspectionDataUpdateDateTime"
                              >
                              </LabelDatefield>
                              <LabelText
                                labelXl="3"
                                labelLg="3"
                                labelMd="3"
                                labelSm="3"
                                textXl="9"
                                textLg="9"
                                textMd="9"
                                textSm="9"
                                type="textarea"
                                label="B.IE.11 Limited Scope Description"
                                id="txt_scope_desc"
                                v-model="item.scopeNote"
                                :isEditable="isEditable && !item.readOnly && !isAccepted"
                                :counter="300"
                                :maxlength="300"
                                :isRequired="!!item.inspType && !['Z', '1', '2', 'E', 'Q'].includes(item.inspType)"
                                @update:modelValue="changesDetected = true"
                                style="padding-right: 3px !important"
                              />
                            </v-col>
                          </v-row>
                          <v-row
                            ><v-col cols="12" class="px-0" style="white-space: break-word">
                              <LabelText
                                labelXl="3"
                                labelLg="3"
                                labelMd="3"
                                labelSm="3"
                                textXl="9"
                                textLg="9"
                                textMd="9"
                                textSm="9"
                                label="B.IE.12 Inspection Equipment"
                                id="txt_insp_equip"
                                v-model="item.equipConcat"
                                :isEditable="false"
                                class="wrapValue"
                              />
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col
                              cols="12"
                              v-if="
                                equipmentError.message?.length > 0 &&
                                equipmentError.message.some((a) => a.includes('Access')) &&
                                !item.readonly
                              "
                              class="errorMessage"
                            >
                              {{ equipmentError.message.find((a) => a.includes("Access")) }}
                            </v-col>
                            <v-col class="align-center sub-section-header">
                              Access Equipment (Check all that apply, at least one is required)
                            </v-col>
                          </v-row>
                          <v-row>
                            <div
                              v-for="accessEquip in accessEquipment"
                              :key="accessEquip.value"
                              style="float: left; width: 12%"
                              class="equipTable"
                            >
                              <v-checkbox
                                :id="`checkbox_access_equip_${accessEquip.value}`"
                                :aria-describedby="`checkbox_access_equip_${accessEquip.value}`"
                                :aria-label="accessEquip.title"
                                :value="accessEquip.value"
                                v-model="item.selectedEquipment"
                                :label="accessEquip.title"
                                hide-details
                                @update:model-value="updateEquipment(item)"
                                :disabled="item.readOnly || isAccepted"
                              />
                            </div>
                          </v-row>
                          <v-row>
                            <v-col
                              cols="12"
                              v-if="
                                equipmentError.message?.length > 0 &&
                                equipmentError.message.some((a) => a.includes('Inspection')) &&
                                !item.readonly
                              "
                              class="errorMessage"
                            >
                              {{ equipmentError.message.find((a) => a.includes("Inspection")) }}
                            </v-col>
                            <v-col class="align-center sub-section-header">
                              Inspection Equipment (Check all that apply, at least one is required)
                            </v-col>
                          </v-row>
                          <v-row>
                            <div
                              v-for="inspEquip in inspectionEquipment"
                              :key="inspEquip.value"
                              style="float: left; width: 11%"
                              class="equipTable"
                            >
                              <v-checkbox
                                :id="`checkbox_access_equip_${inspEquip.value}`"
                                :aria-describedby="`checkbox_access_equip_${inspEquip.value}`"
                                :aria-label="inspEquip.title"
                                :value="inspEquip.value"
                                v-model="item.selectedEquipment"
                                :label="inspEquip.title"
                                hide-details
                                @update:model-value="updateEquipment(item)"
                                :disabled="item.readOnly || isAccepted"
                              />
                            </div>
                          </v-row>
                        </v-form></td
                    ></template>
                    <template v-slot:bottom> </template>
                  </v-data-table> </v-col
              ></v-row> </v-expansion-panel-text
          ></v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-title
              class="d-flex justify-start"
              hide-actions
              expand-icon="fa-solid fa-plus"
              collapse-icon="fa-solid fa-minus"
            >
              <v-icon v-if="!panel.includes(1)" icon="fa-solid fa-plus" />
              <v-icon v-if="panel.includes(1)" icon="fa-solid fa-minus" />
              <h3>SNBI Future Scheduling Information</h3>
            </v-expansion-panel-title>
            <v-expansion-panel-text eager>
              <v-row>
                <v-col>
                  <FutureScheduleTable
                    @update-interval="updateInterval"
                    @update-next-date="updateNextDate"
                    @save-legacy-schedule-data="updateLegacySchedule"
                    :moduleType="futureScheduleModuleType"
                    ref="futureScheduleTable"
                  />
                </v-col>
              </v-row> </v-expansion-panel-text
          ></v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-title
              class="d-flex justify-start"
              hide-actions
              expand-icon="fa-solid fa-plus"
              collapse-icon="fa-solid fa-minus"
            >
              <v-icon v-if="!panel.includes(2)" icon="fa-solid fa-plus" />
              <v-icon v-if="panel.includes(2)" icon="fa-solid fa-minus" />
              <h3>Inspection Information</h3>
            </v-expansion-panel-title>
            <v-expansion-panel-text eager>
              <v-row dense>
                <v-col sm="12" md="6" lg="6" xl="6">
                  <LabelDatefield
                    labelXl="6"
                    labelLg="7"
                    labelMd="7"
                    labelSm="7"
                    textXl="6"
                    textLg="5"
                    textMd="5"
                    textSm="5"
                    id="txt_inspection_start_date"
                    label="IE.05 Inspection Start Date"
                    v-model="scheduleValue.INSPDATE"
                  >
                  </LabelDatefield>
                  <LabelDatefield
                    labelXl="6"
                    labelLg="7"
                    labelMd="7"
                    labelSm="7"
                    textXl="6"
                    textLg="5"
                    textMd="5"
                    textSm="5"
                    label="IE.06 Inspection End Date"
                    v-model="scheduleValue.OVERALL_END_DATE"
                  >
                  </LabelDatefield>
                  <LabelSelect
                    labelXl="6"
                    labelLg="7"
                    labelMd="7"
                    labelSm="7"
                    selectXl="6"
                    selectLg="5"
                    selectMd="5"
                    selectSm="5"
                    id="sel_team_leader"
                    label="IE.07 Team Leader"
                    :options="getTeamLeaders(false)"
                    v-model="scheduleValue.INSPUSRKEY"
                    isNumericValue
                  ></LabelSelect>
                  <LabelSelect
                    labelXl="6"
                    labelLg="7"
                    labelMd="7"
                    labelSm="7"
                    selectXl="6"
                    selectLg="5"
                    selectMd="5"
                    selectSm="5"
                    id="sel_primary_inspection_type"
                    label="IE.08 Primary Inspection Type"
                    :refTable="REFERENCE_TABLE.INSPECTION_TYPE"
                    v-model="scheduleValue.INSPTYPE"
                    isRequired
                  ></LabelSelect>
                  <LabelSelect
                    labelXl="6"
                    labelLg="7"
                    labelMd="7"
                    labelSm="7"
                    selectXl="6"
                    selectLg="5"
                    selectMd="5"
                    selectSm="5"
                    id="sel_inspection_performed_by"
                    label="IE.10 Inspection Performed By"
                    :refTable="REFERENCE_TABLE.INSPECTION_PERFORMED_BY"
                    :isEditable="isEditable"
                    v-model="scheduleValue.INSPECTCONTROLID"
                    isNumericValue
                  ></LabelSelect>

                  <LabelText
                    labelXl="6"
                    labelLg="7"
                    labelMd="7"
                    labelSm="7"
                    textXl="6"
                    textLg="5"
                    textMd="5"
                    textSm="5"
                    id="txt_inspection_organization"
                    label="IE.11 Inspection Organization"
                    v-model="scheduleValue.INSP_ORG_NAME"
                  >
                  </LabelText>

                  <LabelText
                    labelXl="12"
                    labelLg="12"
                    labelMd="12"
                    labelSm="12"
                    textXl="12"
                    textLg="12"
                    textMd="12"
                    textSm="12"
                    id="txt_inspection_team_members"
                    label="IE.12 Inspection Team Member(s)"
                    :isEditable="isEditable"
                    v-model="scheduleValue.INSP_TEAM_HELPER"
                    maxlength="120"
                    type="textarea"
                    counter
                    persistentCounter
                  >
                  </LabelText>
                  <LabelSelect
                    labelXl="6"
                    labelLg="7"
                    labelMd="7"
                    labelSm="7"
                    selectXl="6"
                    selectLg="5"
                    selectMd="5"
                    selectSm="5"
                    id="input_underwater_diver_name"
                    label="IE.13 Underwater Diver Name"
                    :options="underwaterDivers"
                    :isEditable="isEditable"
                    v-model="scheduleValue.UW_DIVER_NAME"
                  ></LabelSelect>
                  <LabelSelect
                    labelXl="6"
                    labelLg="7"
                    labelMd="7"
                    labelSm="7"
                    selectXl="6"
                    selectLg="5"
                    selectMd="5"
                    selectSm="5"
                    id="input_consultant_hired_By"
                    label="IE.14 Consultant Hired By"
                    :refTable="REFERENCE_TABLE.CONSULTANT_HIRED_BY"
                    :isEditable="isEditable"
                    v-model="scheduleValue.CONSULTANT_HIRED_BY"
                  ></LabelSelect>

                  <LabelText
                    labelXl="6"
                    labelLg="7"
                    labelMd="7"
                    labelSm="7"
                    textXl="6"
                    textLg="5"
                    textMd="5"
                    textSm="5"
                    id="input_inspection_agreement_number"
                    label="IE.15 Inspection Agreement Number"
                    :maxlength="6"
                    :counter="false"
                    v-model="scheduleValue.LOCAL_INSP_CONTRACT_NUM"
                    :isEditable="isEditable"
                  >
                  </LabelText>
                  <LabelCheckbox
                    labelXl="6"
                    labelLg="7"
                    labelMd="7"
                    labelSm="7"
                    id="checkbox_UtilityRepair"
                    label="IE.16 Utility Repair Indicator"
                    v-model="scheduleValue.UTILITY_REPAIR"
                    :isEditable="isEditable"
                  ></LabelCheckbox>
                </v-col>
                <v-col sm="12" md="6" lg="6" xl="6">
                  <LabelText
                    labelXl="6"
                    labelLg="7"
                    labelMd="7"
                    labelSm="7"
                    textXl="6"
                    textLg="5"
                    textMd="5"
                    textSm="5"
                    id="txt_extended_inspection_interval_eligibility"
                    label="IE.18 Non-NBIS Extended Inspection Interval Eligibility"
                    :refTable="REFERENCE_TABLE.EXTENDED_INSPECTION_INTERVAL_ELIGIBILITY"
                    v-model="scheduleValue.EXTINSPFREQ_ELIG"
                    :showAuditReason="showExtendedIntervalAuditTooltips"
                    :auditTooltip="scheduleValue.extInspFreqEligReason"
                  >
                  </LabelText>

                  <LabelSelect
                    labelXl="6"
                    labelLg="7"
                    labelMd="7"
                    labelSm="7"
                    textXl="6"
                    textLg="5"
                    textMd="5"
                    textSm="5"
                    :isEditable="
                      isEditable &&
                      hasAccessToEditExtendedInspectionIntervalConcurrence &&
                      moduleType == MODULE_TYPES.MANAGEMENT
                    "
                    id="txt_extended_inspection_interval_concurrence"
                    label="IE.19 Extended Inspection Interval Concurrence"
                    :refTable="REFERENCE_TABLE.INSPECTION_INTERVAL_CONCURRENCE"
                    v-model="scheduleValue.EXTINSPFREQ_CONC"
                  ></LabelSelect>
                  <LabelText
                    labelXl="6"
                    labelLg="7"
                    labelMd="7"
                    labelSm="7"
                    textXl="6"
                    textLg="5"
                    textMd="5"
                    textSm="5"
                    id="txt_nbis_extended_inspection_interval_eligibility"
                    label="IE.20 NBIS Extended Inspection Interval Eligibility"
                    :refTable="REFERENCE_TABLE.METHOD1_ELIGIBILITY"
                    v-model="scheduleValue.METHOD1_ELIG"
                    :showAuditReason="showExtendedIntervalAuditTooltips"
                    :auditTooltip="scheduleValue.method1EligReason"
                  ></LabelText>

                  <LabelSelect
                    labelXl="6"
                    labelLg="7"
                    labelMd="7"
                    labelSm="7"
                    selectXl="6"
                    selectLg="5"
                    selectMd="5"
                    selectSm="5"
                    id="sel_weather_conditions"
                    label="IE.21 Weather"
                    :refTable="REFERENCE_TABLE.WEATHER_CONDITION"
                    :isEditable="isEditable"
                    v-model="scheduleValue.WEATHER_COND"
                  ></LabelSelect>
                  <LabelText
                    labelXl="6"
                    labelLg="7"
                    labelMd="7"
                    labelSm="7"
                    textXl="6"
                    textLg="5"
                    textMd="5"
                    textSm="5"
                    id="input_temperature"
                    :isEditable="isEditable"
                    label="IE.22 Temperature"
                    v-model="scheduleValue.TEMP"
                    allowNegativeInput
                    type="number"
                    :maxlength="6"
                    :decimalPlaces="1"
                    :rules="
                      isEditable
                        ? [
                            (value) => {
                              return valueInRangeRule(value, -50, 200);
                            },
                          ]
                        : []
                    "
                  ></LabelText>
                  <LabelText
                    labelXl="6"
                    labelLg="7"
                    labelMd="7"
                    labelSm="7"
                    textXl="6"
                    textLg="5"
                    textMd="5"
                    textSm="5"
                    id="input_nbi_crew_hours"
                    :isEditable="isEditable"
                    label="IE.23 NBI Crew Hours"
                    v-model="crewHrs"
                    type="number"
                    :maxlength="5"
                    :decimalPlaces="0"
                    :rules="
                      isEditable
                        ? [
                            (value) => {
                              return valueInRangeRule(value, 0, 999);
                            },
                          ]
                        : []
                    "
                  >
                  </LabelText>
                  <LabelText
                    labelXl="6"
                    labelLg="7"
                    labelMd="7"
                    labelSm="7"
                    textXl="6"
                    textLg="5"
                    textMd="5"
                    textSm="5"
                    id="input_crane_hours"
                    :isEditable="isEditable"
                    label="IE.24 Crane Hours"
                    v-model="craneHrs"
                    type="number"
                    :maxlength="5"
                    :decimalPlaces="0"
                    :rules="
                      isEditable
                        ? [
                            (value) => {
                              return valueInRangeRule(value, 0, 999);
                            },
                          ]
                        : []
                    "
                  ></LabelText>
                  <LabelText
                    labelXl="6"
                    labelLg="7"
                    labelMd="7"
                    labelSm="7"
                    textXl="6"
                    textLg="5"
                    textMd="5"
                    textSm="5"
                    id="input_nstm_hours"
                    :isEditable="isEditable"
                    label="IE.25 NSTM Hours"
                    v-model="nstmHrs"
                    type="number"
                    :maxlength="5"
                    :decimalPlaces="0"
                    :rules="
                      isEditable
                        ? [
                            (value) => {
                              return valueInRangeRule(value, 0, 999);
                            },
                          ]
                        : []
                    "
                  ></LabelText>
                  <LabelText
                    labelXl="6"
                    labelLg="7"
                    labelMd="7"
                    labelSm="7"
                    textXl="6"
                    textLg="5"
                    textMd="5"
                    textSm="5"
                    id="input_uw_hours"
                    :isEditable="isEditable"
                    label="IE.26 UW Hours"
                    v-model="helperHrs"
                    type="number"
                    :maxlength="5"
                    :decimalPlaces="0"
                    :rules="
                      isEditable
                        ? [
                            (value) => {
                              return valueInRangeRule(value, 0, 999);
                            },
                          ]
                        : []
                    "
                  ></LabelText>
                  <LabelText
                    labelXl="6"
                    labelLg="7"
                    labelMd="7"
                    labelSm="7"
                    textXl="6"
                    textLg="5"
                    textMd="5"
                    textSm="5"
                    id="input_engineering_costs"
                    :isEditable="isEditable"
                    label="IE.27 Engineering Costs"
                    v-model="scheduleValue.FIELD_ENG_INSP_COST"
                    type="number"
                    maxlength="6"
                  ></LabelText>
                  <LabelText
                    labelXl="6"
                    labelLg="7"
                    labelMd="7"
                    labelSm="7"
                    textXl="6"
                    textLg="5"
                    textMd="5"
                    textSm="5"
                    id="input_rigging_costs"
                    :isEditable="isEditable"
                    label="IE.28 Rigging Costs"
                    v-model="scheduleValue.RIGGING_INSP_COST"
                    type="number"
                    maxlength="6"
                  ></LabelText>
                  <LabelText
                    labelXl="6"
                    labelLg="7"
                    labelMd="7"
                    labelSm="7"
                    textXl="6"
                    textLg="5"
                    textMd="5"
                    textSm="5"
                    id="input_office_costs"
                    :isEditable="isEditable"
                    label="IE.29 Office Costs"
                    v-model="scheduleValue.OFFICE_INSP_COST"
                    type="number"
                    maxlength="6"
                  ></LabelText>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col sm="12" md="12" lg="12" xl="12">
                  <CommentTypeTextField
                    v-if="moduleType == MODULE_TYPES.INSPECTION"
                    label="Utility Repair Notes"
                    id="utility_repair_comment"
                    :inspectionCommentType="INSPECTION_COMMENTS.UTILITY_REPAIR"
                    :readonly="!isEditable"
                    :counter="commentsMaxLength"
                    :maxlength="commentsMaxLength"
                    @changesDetected="inspectionStore.setDirtyFlag(true)"
                  />
                  <ManagementCommentTypeTextField
                    v-else
                    label="Utility Repair Notes"
                    id="utility_repair_comment"
                    :inspectionCommentType="INSPECTION_COMMENTS.UTILITY_REPAIR"
                    :readonly="!isEditable"
                    :counter="commentsMaxLength"
                    :maxlength="commentsMaxLength"
                    :comments="scheduleValue.INSPECTION_COMMENTS"
                    :brkey="scheduleValue.BRKEY"
                    :inspectionId="scheduleValue.INSPECTIONID"
                    @updateComment="(comment) => setUpdatedComment(comment, INSPECTION_COMMENTS.UTILITY_REPAIR)"
                  />
                  <LabelSelect
                    labelXl="3"
                    labelLg="3"
                    labelMd="6"
                    labelSm="6"
                    textXl="3"
                    textLg="3"
                    textMd="6"
                    textSm="6"
                    id="input_inaccessible_area"
                    label="IE.17 Inaccessible Area"
                    :refTable="REFERENCE_TABLE.INACCESSIBLE_AREA"
                    :isEditable="isEditable"
                    v-model="scheduleValue.INACCESS_PORTION_STRUCT"
                  ></LabelSelect>
                  <CommentTypeTextField
                    v-if="moduleType == MODULE_TYPES.INSPECTION"
                    label="Inaccessible Area Notes"
                    id="inaccessible_area_comment"
                    :inspectionCommentType="INSPECTION_COMMENTS.INACCESSIBLE_AREA"
                    :readonly="!isEditable"
                    :counter="commentsMaxLength"
                    :maxlength="commentsMaxLength"
                    @changesDetected="inspectionStore.setDirtyFlag(true)"
                  />
                  <ManagementCommentTypeTextField
                    v-else
                    label="Inaccessible Area Notes"
                    id="inaccessible_area_comment"
                    :inspectionCommentType="INSPECTION_COMMENTS.INACCESSIBLE_AREA"
                    :readonly="!isEditable"
                    :counter="commentsMaxLength"
                    :maxlength="commentsMaxLength"
                    :comments="scheduleValue.INSPECTION_COMMENTS"
                    :brkey="scheduleValue.BRKEY"
                    :inspectionId="scheduleValue.INSPECTIONID"
                    @updateComment="(comment) => setUpdatedComment(comment, INSPECTION_COMMENTS.INACCESSIBLE_AREA)"
                  />
                </v-col>
              </v-row>
            </v-expansion-panel-text>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-title
              class="d-flex justify-start"
              hide-actions
              expand-icon="fa-solid fa-plus"
              collapse-icon="fa-solid fa-minus"
            >
              <v-icon v-if="!panel.includes(3)" icon="fa-solid fa-plus" />
              <v-icon v-if="panel.includes(3)" icon="fa-solid fa-minus" />
              <h3>Next Inspection Information</h3>
            </v-expansion-panel-title>
            <v-expansion-panel-text eager>
              <v-row dense>
                <v-col sm="12" md="6" lg="6" xl="6">
                  <LabelText
                    labelXl="6"
                    labelLg="7"
                    labelMd="7"
                    labelSm="7"
                    textXl="6"
                    textLg="5"
                    textMd="5"
                    textSm="5"
                    id="txt_next_insp_type"
                    readOnly="true"
                    label="IE.30 Next Inspection Type"
                    v-model="scheduleValue.NEXT_INSP_TYPE"
                  ></LabelText>
                  <LabelDatefield
                    labelXl="6"
                    labelLg="7"
                    labelMd="7"
                    labelSm="7"
                    textXl="6"
                    textLg="5"
                    textMd="5"
                    textSm="5"
                    id="txt_next_crane_insp_date"
                    label="IE.31 Next Access Equipment Date"
                    v-model="scheduleValue.NEXT_CRANE_INSP_DATE"
                    :isEditable="isEditable"
                  >
                  </LabelDatefield>
                </v-col>
                <v-col sm="12" md="6" lg="6" xl="6">
                  <LabelSelect
                    labelXl="6"
                    labelLg="7"
                    labelMd="7"
                    labelSm="7"
                    selectXl="6"
                    selectLg="5"
                    selectMd="5"
                    selectSm="5"
                    id="input_next_insp_by"
                    label="IE.32 Next Inspection Performed By"
                    :refTable="REFERENCE_TABLE.NEXT_INSPECTION_BY"
                    v-model="scheduleValue.BRIDGEGROUP"
                    :isEditable="isEditable"
                  ></LabelSelect>
                  <LabelSelect
                    labelXl="6"
                    labelLg="7"
                    labelMd="7"
                    labelSm="7"
                    selectXl="6"
                    selectLg="5"
                    selectMd="5"
                    selectSm="5"
                    id="input_next_insp_leader"
                    label="IE.33 Next Team Leader"
                    :options="getTeamLeaders(false)"
                    v-model="scheduleValue.NEXTINSPID"
                    :isEditable="isEditable"
                  ></LabelSelect>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col sm="12" md="12" lg="12" xl="12">
                <CommentTypeTextField
                    v-if="moduleType == MODULE_TYPES.INSPECTION"
                    label="Future Inspection Limited Scope Notes"
                    id="futureInspectionLimitedScope"
                    :inspectionCommentType="INSPECTION_COMMENTS.FUTURE_INSPECTION_LIMITED_SCOPE"
                    :readonly="!isEditable"
                    :counter="commentsMaxLength"
                    :maxlength="commentsMaxLength"
                    @changesDetected="inspectionStore.setDirtyFlag(true)"
                  />
                  <ManagementCommentTypeTextField
                    v-else
                    label="Future Inspection Limited Scope Notes"
                    id="futureInspectionLimitedScope"
                    :inspectionCommentType="INSPECTION_COMMENTS.FUTURE_INSPECTION_LIMITED_SCOPE"
                    :readonly="!isEditable"
                    :counter="commentsMaxLength"
                    :maxlength="commentsMaxLength"
                    :comments="scheduleValue.INSPECTION_COMMENTS"
                    :brkey="scheduleValue.BRKEY"
                    :inspectionId="scheduleValue.INSPECTIONID"
                    @updateComment="(comment) => setUpdatedComment(comment, INSPECTION_COMMENTS.FUTURE_INSPECTION_LIMITED_SCOPE)"
                  />
                  </v-col>
              </v-row>
            </v-expansion-panel-text>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-title
              class="d-flex justify-start"
              hide-actions
              expand-icon="fa-solid fa-plus"
              collapse-icon="fa-solid fa-minus"
            >
              <v-icon v-if="!panel.includes(4)" icon="fa-solid fa-plus" />
              <v-icon v-if="panel.includes(4)" icon="fa-solid fa-minus" />
              <h3>Legacy Schedule Information</h3>
            </v-expansion-panel-title>
            <v-expansion-panel-text eager>
              <v-row>
                <v-col>
                  <v-table class="compactTable moreCompact">
                    <thead>
                      <tr>
                        <th
                          id="th_none"
                          class="align-center"
                          :style="$vuetify?.display?.smAndDown ? 'width: 25% !important' : ''"
                        >
                          <br />Inspection Type
                        </th>
                        <th
                          id="th_7A06"
                          class="align-center"
                          :style="$vuetify?.display?.smAndDown ? 'width: 15% !important' : ''"
                        >
                          7A06<br />Performed
                        </th>
                        <th
                          id="th_7A07"
                          class="align-center"
                          :style="$vuetify?.display?.smAndDown ? 'width: 15% !important' : ''"
                        >
                          7A07<br />Required
                        </th>
                        <th
                          id="th_7A08"
                          class="align-center"
                          :style="$vuetify?.display?.smAndDown ? 'width: 15% !important' : ''"
                        >
                          7A08<br />Last Inspection<br />Date
                        </th>
                        <th
                          id="th_7A09"
                          class="align-center"
                          :style="$vuetify?.display?.smAndDown ? 'width: 15% !important' : ''"
                        >
                          7A09<br />Inspection<br />Interval
                        </th>
                        <th
                          id="th_7A10"
                          class="align-center"
                          :style="$vuetify?.display?.smAndDown ? 'width: 15% !important' : ''"
                        >
                          7A10<br />Next Inspection<br />Date
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(specificSpan, idx) in tableData" :key="idx" class="align-center">
                        <td>
                          <strong>{{ specificSpan.Title }}</strong>
                        </td>
                        <td>
                          <v-checkbox
                            class="noGridCheckbox justify-center"
                            v-if="specificSpan.showPerfCheckbox"
                            :id="'checkbox_wasPerformed_' + idx"
                            v-model="specificSpan.wasPerformed"
                            :true-value="'1'"
                            :false-value="'0'"
                            hide-details
                            disabled
                          ></v-checkbox>
                        </td>
                        <td>
                          <v-checkbox
                            class="noGridCheckbox justify-center"
                            v-if="specificSpan.showReqCheckbox"
                            :id="'checkbox_isRequired_' + idx"
                            v-model="specificSpan.isRequired"
                            :true-value="'1'"
                            :false-value="'0'"
                            hide-details
                            disabled
                          ></v-checkbox>
                        </td>
                        <td class="justify-center">
                          <LabelDatefield
                            textXl="12"
                            textLg="12"
                            textMd="12"
                            textSm="12"
                            :id="'txt_last_inspection_date_' + idx"
                            v-model="specificSpan.LastInspectionDate"
                          >
                          </LabelDatefield>
                        </td>
                        <td class="justify-center">
                          <LabelText
                            textXl="12"
                            textLg="12"
                            textMd="12"
                            textSm="12"
                            :id="'txt_inspection_interval_' + idx"
                            v-model="specificSpan.InspectionInterval"
                            appendWith=" mos"
                            type="number"
                            allowNegativeInput
                          >
                          </LabelText>
                        </td>
                        <td>
                          <LabelDatefield
                            textXl="12"
                            textLg="12"
                            textMd="12"
                            textSm="12"
                            :id="'txt_next_inspection_date_' + idx"
                            v-model="specificSpan.nextInspectionDate"
                          >
                          </LabelDatefield>
                        </td>
                      </tr>
                    </tbody>
                  </v-table>
                </v-col>
              </v-row>
            </v-expansion-panel-text>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-form>
    </v-col>
  </v-row>
  <ConfirmDialog ref="closeConfirm" :cancelButtonText="BUTTONS.NO" />
</template>

<script>
import { defineComponent, ref, computed, watch, onMounted, nextTick } from "vue";
import { useConfigStore } from "@/stores/config";
import { REFERENCE_TABLE } from "@/constants/ReferenceTables";
import { useInspectionStore } from "@/stores/inspection";
import { requiredRule, valueInRangeRule } from "@/composables/validationRules";
import LabelText from "@/components/common/LabelText.vue";
import LabelSelect from "@/components/common/LabelSelect.vue";
import LabelDatefield from "@/components/common/LabelDatefield.vue";
import { ROUNDING_FACTOR } from "@/constants/RoundingFactors";
import inspectionType from "@/data/inspectionType";
import { clone } from "@/util/clone";
import DataTableHeader from "@/components/common/DataTableHeader.vue";
import IconTooltip from "@/components/common/IconTooltip.vue";
import { getFormattedDateStringNoTime } from "@/composables/dateField.js";
import ConfirmDialog from "@/components/common/ConfirmDialog.vue";
import { INSPECTION_MESSAGES, MODULE_TYPES } from "@/constants/InspectionConstants";
import { INSPECTION_TYPE_PERFORMED, INSPECTION_COMMENTS } from "@/constants/Inspections";
import { BUTTONS } from "@/constants/CommonWebConstants";
import { LOGGER } from "@/util/logger";
import { scrollToDataTable } from "@/util/scrollToElement";
import FutureScheduleTable from "@/components/shared/FutureScheduleTable.vue";
import { sortEquipmentArray } from "@/composables/util";
import ExpandCollapseToggle from "@/components/shared/ExpandCollapseToggle.vue";
import LabelCheckbox from "@/components/common/LabelCheckbox.vue";
import { useSnackbarStore } from "@/stores/snackbar";
import { SNACKBAR_MARKER, SNACKBAR_MESSAGE_TYPES } from "@/constants/GlobalSnackbar.js";
import CommentTypeTextField from "@/components/common/CommentTypeTextField.vue";
import { ENV_CONFIG_PROPERTY } from "@/constants/EnvConfigProperties";
import { useInspectionLinksStore } from "@/stores/inspectionLinks";
import { useUserPermissionStore } from "@/stores/userPermission";
import { INSPECTION_LINKS_SCHEDULE_PERMISSIONS } from "@/rbac";
import { ACCESS_LEVELS } from "@/rbac/accessLevels.js";
import { useQuickSearchStore } from "@/stores/quickSearch";
import { storeToRefs } from "pinia";
import { useScheduleStore } from "@/components/inspection/store/schedule";
import ManagementCommentTypeTextField from "@/components/common/ManagementCommentTypeTextField.vue";
import { INSPECTION_STATUSES } from "@/constants/InspectionStatuses";
import { calculateNextInspType } from "@/composables/futureSchedule";
import ValidationCountsHeader from "@/components/shared/ValidationCountsHeader.vue";

export default defineComponent({
  name: "InspectionSchedule",
  props: {
    moduleType: { default: MODULE_TYPES.INSPECTION },
  },
  setup(props, ctx) {
    const allPanels = [0, 1, 2, 3, 4];
    const panel = ref(allPanels);

    const inspectionStore = useInspectionStore();
    const configStore = useConfigStore();
    const snackbarStore = useSnackbarStore();
    const inspectionLinksStore = useInspectionLinksStore();
    const userPermissionStore = useUserPermissionStore();
    const quickSearchStore = useQuickSearchStore();
    const structureHeader = computed(() => quickSearchStore.getStructure());
    const { hasQuickSearchSucceeded } = storeToRefs(quickSearchStore);
    const scheduleStore = useScheduleStore();

    let valid = ref(true);
    let schedulePageValid = ref(true);
    let modifyInspectionScheduleForm = ref(null);
    const structure = computed(() => inspectionStore.selectedInspection);
    let scheduleValue = ref({});

    const isAccepted = computed({
      get() {
        if (props.moduleType == MODULE_TYPES.MANAGEMENT) {
          return structureHeader.value?.INSPECTIONSTATUS === INSPECTION_STATUSES.ACCEPTED;
        } else {
          return scheduleValue.value?.INSPSTAT === INSPECTION_STATUSES.ACCEPTED;
        }
      },
    });

    const hasAccessToEdit = computed({
      get() {
        if (structureHeader.value?.INSPECTIONSTATUS === INSPECTION_STATUSES.ACCEPTED) {
          return userPermissionStore.checkUserPermission(
            INSPECTION_LINKS_SCHEDULE_PERMISSIONS[ACCESS_LEVELS.CUSTOM.EDIT_APPROVED_INSPECTION],
            userPermissionStore.getUserPermissionByBrkeyFromCache(scheduleValue.value.BRKEY),
          );
        } else {
          return userPermissionStore.checkUserPermission(
            INSPECTION_LINKS_SCHEDULE_PERMISSIONS[ACCESS_LEVELS.EDIT],
            userPermissionStore.getUserPermissionByBrkeyFromCache(scheduleValue.value.BRKEY),
          );
        }
      },
    });

    const isEditable = computed({
      get() {
        if (props.moduleType == MODULE_TYPES.MANAGEMENT) {
          return hasQuickSearchSucceeded.value && scheduleValue.value?.BRKEY && hasAccessToEdit.value;
        } else {
          return inspectionStore.isEditable;
        }
      },
    });

    const showExtendedIntervalAuditTooltips = computed({
      get() {
        return props.moduleType == MODULE_TYPES.MANAGEMENT && scheduleValue.value?.method1EligReason != null;
      },
    });

    let equipmentError = ref({ message: [] });
    let futureScheduleTable = ref(null);
    let snackBarId = ref("");
    let onlyNSTMErrorId = ref("");
    let inspTypeBothErrorId = ref("");
    let equipmentErrorId = ref("");

    async function validate() {
      await modifyInspectionScheduleForm.value.validate();
      await futureScheduleTable?.value?.validateForm();
      let isTypesCombinationValid = isValidInspTypes();
      // Page is only valid if itself and the future schedule table are good
      valid.value = schedulePageValid.value && futureScheduleTable?.value?.validFutureForm && isTypesCombinationValid;
    }

    const tableData = computed({
      get() {
        return [
          {
            Title: "NBI:",
            showPerfCheckbox: true,
            showReqCheckbox: false,
            wasPerformed: scheduleValue?.value?.NBINSPDONE,
            isRequired: "",
            LastInspectionDate: scheduleValue?.value?.LASTINSP,
            InspectionInterval: scheduleValue?.value?.BRINSPFREQ,
            nextInspectionDate: scheduleValue?.value?.NEXTINSP,
          },
          {
            Title: "NSTM:",
            showPerfCheckbox: true,
            showReqCheckbox: true,
            wasPerformed: scheduleValue?.value?.FCINSPDONE,
            isRequired: scheduleValue?.value?.FCINSPREQ,
            LastInspectionDate: scheduleValue?.value?.FCLASTINSP,
            InspectionInterval: scheduleValue?.value?.FCINSPFREQ,
            nextInspectionDate: scheduleValue?.value?.FCNEXTDATE,
          },
          {
            Title: "Underwater:",
            showPerfCheckbox: true,
            showReqCheckbox: true,
            wasPerformed: scheduleValue?.value?.UWINSPDONE,
            isRequired: scheduleValue?.value?.UWINSPREQ,
            LastInspectionDate: scheduleValue?.value?.UWLASTINSP,
            InspectionInterval: scheduleValue?.value?.UWINSPFREQ,
            nextInspectionDate: scheduleValue?.value?.UWNEXTDATE,
          },
          {
            Title: "Other Special:",
            showPerfCheckbox: true,
            showReqCheckbox: true,
            wasPerformed: scheduleValue?.value?.OSINSPDONE,
            isRequired: scheduleValue?.value?.OSINSPREQ,
            LastInspectionDate: scheduleValue?.value?.OSLASTINSP,
            InspectionInterval: scheduleValue?.value?.OSINSPFREQ,
            nextInspectionDate: scheduleValue?.value?.OSNEXTDATE,
          },
          {
            Title: "Element:",
            showPerfCheckbox: true,
            showReqCheckbox: true,
            wasPerformed: scheduleValue?.value?.ELINSPDONE,
            isRequired: scheduleValue?.value?.ELINSPREQ,
            LastInspectionDate: scheduleValue?.value?.ELLASTINSP,
            InspectionInterval: scheduleValue?.value?.ELINSPFREQ,
            nextInspectionDate: scheduleValue?.value?.ELNEXTDATE,
          },
        ];
      },
    });

    const underwaterDivers = computed(() => configStore.getUnderwaterDivers);

    const getTeamLeaders = (isNSTM) => {
      return configStore.getTeamLeaders(scheduleValue.value, isNSTM);
    };

    let organizations = computed(() => configStore.getOrganizations);
    let users = computed(() => configStore.getUsers);

    let updateInspectionOrganization = () => {
      let bpId = users.value.find((a) => a.userId == scheduleValue?.value?.INSPUSRKEY)?.bpId;
      if (bpId == null) {
        scheduleValue.value.INSP_ORG_NAME = "Penndot";
      } else {
        scheduleValue.value.INSP_ORG_NAME = organizations.value.find(
          (a) => a.organization.bpId == bpId,
        )?.organization?.bpName;
      }
    };

    let crewHrs = computed({
      get() {
        return Number.parseFloat(scheduleValue?.value?.CREWHRS).toFixed(0);
      },
      set(crewHrsParam) {
        if (crewHrsParam || crewHrsParam == 0) {
          scheduleValue.value.CREWHRS = Number.parseFloat(crewHrsParam).toFixed(0);
        } else {
          scheduleValue.value.CREWHRS = null;
        }
      },
    });

    let craneHrs = computed({
      get() {
        return Number.parseFloat(scheduleValue?.value?.SNOOPERHRS).toFixed(0);
      },
      set(craneHrsParam) {
        if (craneHrsParam || craneHrsParam == 0) {
          scheduleValue.value.SNOOPERHRS = Number.parseFloat(craneHrsParam).toFixed(0);
        } else {
          scheduleValue.value.SNOOPERHRS = null;
        }
      },
    });

    let nstmHrs = computed({
      get() {
        return Number.parseFloat(scheduleValue?.value?.FLAGGERHRS).toFixed(0);
      },
      set(nstmHrsParam) {
        if (nstmHrsParam || nstmHrsParam == 0) {
          scheduleValue.value.FLAGGERHRS = Number.parseFloat(nstmHrsParam).toFixed(0);
        } else {
          scheduleValue.value.FLAGGERHRS = null;
        }
      },
    });

    let helperHrs = computed({
      get() {
        return Number.parseFloat(scheduleValue?.value?.HELPERHRS).toFixed(0);
      },
      set(helperHrsParam) {
        if (helperHrsParam || helperHrsParam == 0) {
          scheduleValue.value.HELPERHRS = Number.parseFloat(helperHrsParam).toFixed(0);
        } else {
          scheduleValue.value.HELPERHRS = null;
        }
      },
    });
    let expandedRows = ref([]);
    let inspectionTypes = ref([]);
    let sortBy = ref([{ key: "inspType", order: "asc" }]);
    let previousSort = ref([{ key: "inspType", order: "asc" }]);

    let validDetails = ref(false);
    let inspTypeDetailForm = ref(null);
    let changesDetected = ref(false);
    const closeConfirm = ref(null);

    const anyEditable = computed(() => {
      return expandedRows.value?.some((element) => !element.readOnly);
    });
    const getNewInspectionType = () => {
      return clone(inspectionType);
    };

    const inspTypeHeaders = [
      {
        key: "data-table-expand",
        width: "1%",
      },
      {
        line1: "B.IE.01",
        line2: "Inspection",
        line3: "Type",
        key: "inspType",
        sortable: true,
        width: "15%",
      },
      {
        line1: "B.IE.02",
        line2: "Inspection",
        line3: "Start Date",
        key: "startDate",
        sortable: false,
        width: "10%",
      },
      {
        line1: "B.IE.03",
        line2: "Inspection",
        line3: "End Date",
        key: "endDate",
        sortable: false,
        width: "10%",
      },
      {
        line1: "B.IE.04",
        line2: "NCBI",
        line3: "(Team Leader)",
        key: "teamLeader",
        sortable: false,
        width: "15%",
      },
      {
        line1: "B.IE.05",
        line2: "Inspection",
        line3: "Interval",
        key: "inspInterval",
        sortable: false,
        width: "10%",
      },
      {
        line1: "B.IE.06",
        line2: "Inspection",
        line3: "Due Date",
        key: "dueDate",
        sortable: false,
        width: "10%",
      },
      {
        line1: "B.IE.07",
        line2: "RBI",
        line3: "Method",
        key: "rbm",
        sortable: false,
      },
      {
        line1: null,
        line2: "Action",
        line3: null,
        key: "action",
        sortable: false,
        width: "5%",
      },
    ];

    const getAllInspectionTypes = () => {
      expandedRows.value = [];
      inspectionTypes.value = clone(scheduleValue.value?.SNBI_INSPECTION_TYPES);
      if (inspectionTypes.value?.length > 0) {
        for (const event of inspectionTypes.value ?? []) {
          //Update equipment
          const selectedEquip = [];
          for (let prop in event) {
            if (prop.startsWith("equip") && event[prop] === "1") {
              selectedEquip.push(prop.replace("equip", ""));
            }
          }
          event.selectedEquipment = selectedEquip;
          event.readOnly = true;
        }
      } else {
        inspectionTypes.value = [];
      }
    };

    const setScheduleValues = (detail) => {
      switch (detail.inspType) {
        case "2":
          detail.inspInterval = scheduleValue.value?.ROU_INTERVAL || 0;
          detail.dueDate = scheduleValue.value?.ROU_NEXT_DATE;
          break;
        case "3":
          detail.inspInterval = scheduleValue.value?.UW_INTERVAL || 0;
          detail.dueDate = scheduleValue.value?.UW_NEXT_DATE;
          break;
        case "4":
          detail.inspInterval = scheduleValue.value?.NSTM_INTERVAL || 0;
          detail.dueDate = scheduleValue.value?.NSTM_NEXT_DATE;
          break;
        case "6":
          detail.inspInterval = scheduleValue.value?.IND_INTERVAL || 0;
          detail.dueDate = scheduleValue.value?.IND_NEXT_DATE;
          break;
        case "7":
          detail.inspInterval = scheduleValue.value?.OS_INTERVAL || 0;
          detail.dueDate = scheduleValue.value?.OS_NEXT_DATE;
          break;
        case "8":
          detail.inspInterval = scheduleValue.value?.SERV_INTERVAL || 0;
          detail.dueDate = scheduleValue.value?.SERV_NEXT_DATE;
          break;
        case "E":
          detail.inspInterval = scheduleValue.value?.ELEM_INTERVAL || 0;
          detail.dueDate = scheduleValue.value?.ELEM_NEXT_DATE;
          break;
      }
    };

    const addInspType = () => {
      setAddingOrEditingValue(true);
      snackBarId.value = snackbarStore.showMessage({
        displayText: INSPECTION_MESSAGES.SNBI_EVENTS_DATATABLE,
      });
      let inspType = getNewInspectionType();
      inspType.isAdd = true;
      inspType.readOnly = false;
      inspType.selectedEquipment = [];
      inspType.brkey = scheduleValue.value.BRKEY;
      inspType.inspectionId = scheduleValue.value.INSPECTIONID;
      inspectionTypes.value.unshift(inspType);
      previousSort.value = sortBy.value.map((x) => x);
      sortBy.value = [];
      expandedRows.value = [inspType];
      scrollToDataTable("inspectionTypes-data-table");
      const isEquipValid = checkEquipmentValidations(inspType);
      equipmentError.value.message = isEquipValid.message;

      nextTick(() => {
        inspTypeDetailForm.value?.validate();
      });
    };
    const editInspType = (detail) => {
      detail.teamLeader = String(detail.teamLeader);
      equipmentError.value.message = [];
      previousSort.value = sortBy.value.map((x) => x);
      setAddingOrEditingValue(true);
      snackBarId.value = snackbarStore.showMessage({
        displayText: INSPECTION_MESSAGES.SNBI_EVENTS_DATATABLE,
      });
      detail.readOnly = false;
      //if all required fields entered - close the expanded row
      expandedRows.value = [detail];
      const isEquipValid = checkEquipmentValidations(detail);
      equipmentError.value.message = isEquipValid.message;
      nextTick(() => {
        inspTypeDetailForm.value?.validate();
        const isEquipValid = checkEquipmentValidations(detail);
        equipmentError.value.message = isEquipValid.message;
      });
      sortBy.value = [];
    };

    const deleteInspType = (detail) => {
      const deleteIndex = scheduleValue.value.SNBI_INSPECTION_TYPES.findIndex((a) => a.inspType === detail.inspType);
      if (deleteIndex > -1) {
        scheduleValue.value.SNBI_INSPECTION_TYPES.splice(deleteIndex, 1);
        expandedRows.value = [];
        getAllInspectionTypes();
      }
    };

    const closeInspType = () => {
      if (isEditable.value && changesDetected.value) {
        //show confirmation dialog on closing
        closeConfirm.value
          .open(INSPECTION_MESSAGES.DETECT_DATATABLE_CHANGE_CONFIRMATION_MESSAGE, BUTTONS.YES)
          .then((response) => {
            if (!response) {
              getAllInspectionTypes();
              expandedRows.value = [];
              sortBy.value = previousSort.value?.map((x) => x);
              setAddingOrEditingValue(false);
              snackbarStore.removeMessage(snackBarId.value);
              changesDetected.value = false;
              equipmentError.value.message = [];
            }
          });
      } else {
        sortBy.value = previousSort.value?.map((x) => x);
        getAllInspectionTypes();
        expandedRows.value = [];
        setAddingOrEditingValue(false);
        snackbarStore.removeMessage(snackBarId.value);
        equipmentError.value.message = [];
      }
    };
    const saveInspType = (detail) => {
      validationSnackbar.value = false;
      const isEquipValid = checkEquipmentValidations(detail);
      //equipConcat field <=120
      const selectedEquipInRange = validateEquipment(detail);
      //check date fields
      const areDatesValid = detail.startDate;
      inspTypeDetailForm.value
        .validate()
        .then(() => {
          if (validDetails.value && isEquipValid?.valid && areDatesValid && selectedEquipInRange?.valid) {
            inspectionStore.setShowValidationSnackbar(false);
            //If the array does not yet exist (no snbi inspection types ever added), then we need to intialize the array
            if (!scheduleValue.value?.SNBI_INSPECTION_TYPES) {
              scheduleValue.value.SNBI_INSPECTION_TYPES = [];
            }
            if (scheduleValue.value?.SNBI_INSPECTION_TYPES?.[0]) {
              //remove null values from array(if any)
              scheduleValue.value.SNBI_INSPECTION_TYPES = scheduleValue.value.SNBI_INSPECTION_TYPES?.filter((a) => !!a);
            }
            detail.modDate = new Date().toISOString();
            if (detail.isAdd) {
              //remove the "isAdd" property from the object pushed into the array, so any future
              //edits do not lead to duplicate insertions
              delete detail.isAdd;
              scheduleValue.value.SNBI_INSPECTION_TYPES.push(detail);
              updateFutureNextDate(detail);
            } else if (changesDetected.value) {
              //update existing detail
              const updateIndex = scheduleValue.value.SNBI_INSPECTION_TYPES.findIndex(
                (a) => a.inspType === detail.inspType,
              );
              scheduleValue.value.SNBI_INSPECTION_TYPES.splice(updateIndex, 1, detail);
            }
            changesDetected.value = false;
            //if all required fields entered - close the expanded row
            expandedRows.value = [];
            setAddingOrEditingValue(false);
            snackbarStore.removeMessage(snackBarId.value);
            getAllInspectionTypes();
            sortBy.value = previousSort.value?.map((x) => x);
          } else if (!validDetails.value) {
            validationSnackbar.value = true;
          } else if (!isEquipValid?.valid) {
            validationSnackbar.value = true;
            showEquipmentError(isEquipValid);
          } else if (!selectedEquipInRange?.valid) {
            validationSnackbar.value = true;
            showEquipmentError(selectedEquipInRange);
          }
        })
        .catch((err) => {
          LOGGER.logException(err);
          changesDetected.value = false;
        });
    };

    let validationSnackbar = computed({
      get() {
        if (props.moduleType === MODULE_TYPES.MANAGEMENT) {
          return inspectionLinksStore.showValidationSnackbar;
        } else {
          return inspectionStore.getShowValidationSnackbar;
        }
      },
      set(value) {
        if (props.moduleType === MODULE_TYPES.MANAGEMENT) {
          inspectionLinksStore.showValidationSnackbar = value;
        } else {
          inspectionStore.setShowValidationSnackbar(value);
        }
      },
    });

    const showEquipmentError = (isEquipValid) => {
      if (isEquipValid.snackbarMessage) {
        equipmentErrorId.value = snackbarStore.showMessage({
          displayText: isEquipValid.snackbarMessage,
          timeout: -1,
          messageType: SNACKBAR_MESSAGE_TYPES.ERROR,
        });
      } else {
        equipmentError.value.message = isEquipValid.message;
      }
    };

    const rowClass = (data) => {
      return expandedRows.value.includes(data) ? "rowSelect" : "rowUnselect";
    };

    const toggleRow = (detail) => {
      if (expandedRows.value.includes(detail)) {
        const index = expandedRows.value.findIndex((d) => d.inspType == detail.inspType);
        expandedRows.value.splice(index, 1);
      } else {
        expandedRows.value.push(detail);
      }
    };
    const isExpanded = (details) => {
      return expandedRows.value?.findIndex((a) => a.inspType == details.inspType) >= 0;
    };

    const getAllEquipment = () => {
      const accessEquipment = [];
      const inspectionEquipment = [];
      const allEquips = configStore.getReferenceValues(REFERENCE_TABLE.INSPECTION_EQUIPMENT, null, null, true);
      for (const equipment of allEquips ?? []) {
        if (equipment.value.startsWith("A")) {
          accessEquipment.push(equipment);
        } else {
          inspectionEquipment.push(equipment);
        }
      }

      return [sortEquipmentArray(accessEquipment), sortEquipmentArray(inspectionEquipment)];
    };
    const [accessEquipment, inspectionEquipment] = getAllEquipment();

    const updateEquipment = (inspType) => {
      snackbarStore.removeMessage(equipmentErrorId.value);
      if (
        inspType.selectedEquipment?.some((a) => a.startsWith("A")) &&
        equipmentError.value.message.some((a) => a.includes("Access"))
      ) {
        equipmentError.value.message?.splice(
          equipmentError.value.message.findIndex((a) => a.includes("Access")),
          1,
        );
      } else if (
        inspType.selectedEquipment?.some((a) => a.startsWith("I")) &&
        equipmentError.value.message.some((a) => a.includes("Inspection"))
      ) {
        equipmentError.value.message?.splice(
          equipmentError.value.message.findIndex((a) => a.includes("Inspection")),
          1,
        );
      }
      if (
        !inspType.selectedEquipment?.some((a) => a.startsWith("A")) ||
        !inspType.selectedEquipment?.some((a) => a.startsWith("I"))
      ) {
        const isEquipValid = checkEquipmentValidations(inspType);
        equipmentError.value.message = isEquipValid.message;
      }
      snackbarStore.removeMessage(equipmentErrorId.value);

      //reset all equipments
      for (const key of Object.keys(inspType) ?? []) {
        if (key.startsWith("equip")) {
          inspType[key] = "0";
        }
      }
      //set values for individual properties
      for (const e of inspType.selectedEquipment ?? []) {
        inspType[`equip${e}`] = "1";
      }
      inspType.equipConcat = inspType.selectedEquipment?.sort()?.join("|");
    };
    //Map to set the SNBI insp type hierarchy(rank)
    const inspTypeHierarchy = new Map();
    inspTypeHierarchy.set("Z", {
      snbiInspType: "Z",
      rank: "1",
      inspType: "Z", //7A03
    });
    inspTypeHierarchy.set("1", {
      snbiInspType: "1",
      rank: "2",
      inspType: "F", //7A03
      inspectionPerformed: "NBINSPDONE", //7A06
      nextInspectionDate: "NEXTINSP", //7A10
    });
    inspTypeHierarchy.set("2", {
      snbiInspType: "2",
      rank: "3",
      inspType: "R", //7A03
      inspectionPerformed: "NBINSPDONE", //7A06
      nextInspectionDate: "NEXTINSP", //7A10
    });
    inspTypeHierarchy.set("7", {
      snbiInspType: "7",
      rank: "4",
      inspType: "I", //7A03
      inspectionPerformed: "OSINSPDONE", //7A06
      nextInspectionDate: "OSNEXTDATE", //7A10
    });
    inspTypeHierarchy.set("3", {
      snbiInspType: "3",
      rank: "5",
      inspType: "U", //7A03
      inspectionPerformed: "UWINSPDONE", //7A06
      nextInspectionDate: "UWNEXTDATE", //7A10
    });
    inspTypeHierarchy.set("5", {
      snbiInspType: "5",
      rank: "6",
      inspType: "B", //7A03
    });
    inspTypeHierarchy.set("6", {
      snbiInspType: "6",
      rank: "7",
      inspType: "D", //7A03
    });
    inspTypeHierarchy.set("9", {
      snbiInspType: "9",
      rank: "8",
      inspType: "P", //7A03
    });
    inspTypeHierarchy.set("P", {
      snbiInspType: "P",
      rank: "9",
      inspType: "P", //7A03
    });
    inspTypeHierarchy.set("8", {
      snbiInspType: "8",
      rank: "10",
      inspType: "H", //7A03
    });
    inspTypeHierarchy.set("E", {
      snbiInspType: "E",
      rank: "11",
      inspType: "E", //7A03
      inspectionPerformed: "ELINSPDONE", //7A06
      nextInspectionDate: "ELNEXTDATE", //7A10
    });
    inspTypeHierarchy.set("4", {
      snbiInspType: "4",
      rank: "12",
      inspectionPerformed: "FCINSPDONE", //7A06
      nextInspectionDate: "FCNEXTDATE", //7A10
    });
    inspTypeHierarchy.set("Q", {
      snbiInspType: "Q",
      rank: "13",
      inspType: "M", //7A03
    });

    const isValidInspTypes = () => {
      snackbarStore.removeMessage(inspTypeBothErrorId.value);
      snackbarStore.removeMessage(onlyNSTMErrorId.value);

      if (inspectionTypes.value.length === 1 && inspectionTypes.value[0].inspType == "4") {
        onlyNSTMErrorId.value = snackbarStore.showMessage({
          displayText: `The page cannot be saved since it would make "4-NSTM" the only inspection
      type and that's invalid.`,
          messageType: SNACKBAR_MESSAGE_TYPES.ERROR,
        });
        return false;
      } else if (
        inspectionTypes.value?.find((a) => a.inspType == "1") &&
        inspectionTypes.value?.find((a) => a.inspType == "2")
      ) {
        inspTypeBothErrorId.value = snackbarStore.showMessage({
          displayText: `Cannot perform a "${configStore.getReferenceValue(
            REFERENCE_TABLE.SNBI_INSPECTION_TYPE,
            1,
          )}" and "${configStore.getReferenceValue(
            REFERENCE_TABLE.SNBI_INSPECTION_TYPE,
            2,
          )}" types on the same inspection.`,
          timeout: 10000,
          messageType: SNACKBAR_MESSAGE_TYPES.ERROR,
        });
        return false;
      }
      return true;
    };

    //Update fields based on SNBI inspections
    const updateFieldDependencies = () => {
      updateInspPerformed();
      //update legacy schedule fields based on future table data
      futureScheduleTable.value.saveLegacyScheduleData();
      if (scheduleValue.value.SNBI_INSPECTION_TYPES?.length > 0) {
        updatePrimaryInspType();
        updateInspStartDate();
        updateMaxEndDate();
        updateTeamLeader();
        updateInspectionOrganization();
      }
    };

    //Update legacy schedule on entire page save
    const updateLegacySchedule = (futureScheduleData) => {
      // Get Routine insp type
      const inspTypeRoutine = futureScheduleData?.find(
        (inspTypeDetail) => "2" == inspTypeDetail.inspType && inspTypeDetail.is7A57RequiredValue == "1",
      );

      // Get Service insp type
      const inspTypeService = futureScheduleData?.find(
        (inspTypeDetail) => "8" == inspTypeDetail.inspType && inspTypeDetail.is7A57RequiredValue == "1",
      );

      let inspDetail = {
        lastInspectionDate: null,
        inspectionInterval: 0,
        inspectionDueDate: null,
      };

      if (inspTypeRoutine) {
        inspDetail = inspTypeRoutine;
      } else if (inspTypeService) {
        inspDetail = inspTypeService;
      }
      //NBI
      //update 7A08
      scheduleValue.value.LASTINSP = inspDetail.lastInspectionDate;
      //update 7A09
      scheduleValue.value.BRINSPFREQ = scheduleStore.getInterval(inspDetail);
      //update 7A10
      scheduleValue.value.NEXTINSP = inspDetail.inspectionDueDate;

      for (const inspTypeDetail of futureScheduleData ?? []) {
        switch (inspTypeDetail.inspType) {
          case "3":
            //update 7A07
            scheduleValue.value.UWINSPREQ = inspTypeDetail.is7A57RequiredValue;
            //update 7A08
            scheduleValue.value.UWLASTINSP = inspTypeDetail.lastInspectionDate;
            //update 7A09
            scheduleValue.value.UWINSPFREQ = scheduleStore.getInterval(inspTypeDetail);
            //update 7A10
            scheduleValue.value.UWNEXTDATE = inspTypeDetail.inspectionDueDate;
            break;
          case "4":
            //update 7A07
            scheduleValue.value.FCINSPREQ = inspTypeDetail.is7A57RequiredValue;
            //update 7A08
            scheduleValue.value.FCLASTINSP = inspTypeDetail.lastInspectionDate;
            //update 7A09
            scheduleValue.value.FCINSPFREQ = scheduleStore.getInterval(inspTypeDetail);
            //update 7A10
            scheduleValue.value.FCNEXTDATE = inspTypeDetail.inspectionDueDate;
            break;
          case "E":
            //update 7A07
            scheduleValue.value.ELINSPREQ = inspTypeDetail.is7A57RequiredValue;
            //update 7A08
            scheduleValue.value.ELLASTINSP = inspTypeDetail.lastInspectionDate;
            //update 7A09
            scheduleValue.value.ELINSPFREQ = scheduleStore.getInterval(inspTypeDetail);
            //update 7A10
            scheduleValue.value.ELNEXTDATE = inspTypeDetail.inspectionDueDate;
            break;
          case "7":
            //update 7A07
            scheduleValue.value.OSINSPREQ = inspTypeDetail.is7A57RequiredValue;
            //update 7A08
            scheduleValue.value.OSLASTINSP = inspTypeDetail.lastInspectionDate;
            //update 7A09
            scheduleValue.value.OSINSPFREQ = scheduleStore.getInterval(inspTypeDetail);
            //update 7A10
            scheduleValue.value.OSNEXTDATE = inspTypeDetail.inspectionDueDate;
        }
      }
    };

    const updatePrimaryInspType = () => {
      const selectedInspTypeArray = [];
      const selectedSnbiInspTypeValueArray = [];
      for (const type of inspectionTypes.value ?? []) {
        const inspType = inspTypeHierarchy.get(type.inspType);
        selectedInspTypeArray.push(inspType);
        selectedSnbiInspTypeValueArray.push(inspType?.snbiInspType);
      }
      if (selectedSnbiInspTypeValueArray.includes("2") && selectedSnbiInspTypeValueArray.includes("3")) {
        //2,3 is present set the primary to W
        scheduleValue.value.INSPTYPE = "W";
      } else {
        //get the lowest rank element's inspType value
        scheduleValue.value.INSPTYPE = selectedInspTypeArray?.reduce(
          (prev, current) => (+prev.rank < +current.rank ? prev : current),
          { rank: Infinity, inspType: null }, // Default initial value
        )?.inspType;
      }
    };
    const updateInspPerformed = () => {
      const selectedInspTypeArray = [];

      for (const type of inspectionTypes.value ?? []) {
        selectedInspTypeArray.push(inspTypeHierarchy.get(type.inspType));
      }

      //reset all checkboxes - 7A06
      scheduleValue.value.NBINSPDONE = "0";
      scheduleValue.value.UWINSPDONE = "0";
      scheduleValue.value.FCINSPDONE = "0";
      scheduleValue.value.ELINSPDONE = "0";
      scheduleValue.value.OSINSPDONE = "0";

      for (const type of selectedInspTypeArray ?? []) {
        if (type.inspectionPerformed) {
          scheduleValue.value[type.inspectionPerformed] = "1";
        }
      }
    };

    const updateInspStartDate = () => {
      const selectedInspTypeArray = [];
      for (const type of inspectionTypes.value ?? []) {
        selectedInspTypeArray.push(inspTypeHierarchy.get(type.inspType));
      }
      //get the lowest rank element's inspType value
      const inspType = selectedInspTypeArray?.reduce(
        (prev, current) => (+prev?.rank < +current?.rank ? prev : current),
        null,
      )?.snbiInspType;

      scheduleValue.value.INSPDATE = inspectionTypes.value.find((t) => t.inspType == inspType)?.startDate;
    };

    const setInspTypeFieldDependencies = (detail) => {
      changesDetected.value = true;
      detail.teamLeader = "";
      //set interval value 0 for the following types
      if (["Z", "1", "5", "9", "P", "Q"].includes(detail.inspType)) {
        detail.inspInterval = 0;
        detail.dueDate = null;
      } else {
        // get values from schedule object and set
        setScheduleValues(detail);
      }
      updateRBI(detail);
      inspTypeDetailForm.value?.validate();
    };

    const updateRBI = (detail) => {
      if (["S1", "A1", "L1"].includes(scheduleValue.value.REPORTGROUP) && ["2", "3", "4"].includes(detail.inspType)) {
        detail.rbm = "1";
      } else {
        detail.rbm = "N";
      }
    };

    //Update interval value in the SNBI Inspection Types performed section
    const updateInterval = (inspTypeDetail) => {
      //update interval
      let snbiEvent = scheduleValue.value.SNBI_INSPECTION_TYPES.find((t) => t.inspType === inspTypeDetail.inspType);
      if (snbiEvent) {
        snbiEvent.inspInterval = inspTypeDetail.inspectionInterval;
      }

      //instead of refreshing the entire inspections- updated the cloned insp used for display
      let clonedSnbiEvent = inspectionTypes.value.find((t) => t.inspType === inspTypeDetail.inspType);
      if (clonedSnbiEvent) {
        clonedSnbiEvent.inspInterval = inspTypeDetail.inspectionInterval;
      }

      //finally, update the scheduleValue object that feeds the page
      switch (inspTypeDetail.inspType) {
        case "2":
          scheduleValue.value.ROU_REQUIRED = inspTypeDetail.is7A57RequiredValue;
          scheduleValue.value.ROU_INTERVAL = inspTypeDetail.inspectionInterval;
          break;
        case "3":
          scheduleValue.value.UW_REQUIRED = inspTypeDetail.is7A57RequiredValue;
          scheduleValue.value.UW_INTERVAL = inspTypeDetail.inspectionInterval;
          break;
        case "4":
          scheduleValue.value.NSTM_REQUIRED = inspTypeDetail.is7A57RequiredValue;
          scheduleValue.value.NSTM_INTERVAL = inspTypeDetail.inspectionInterval;
          break;
        case "6":
          scheduleValue.value.IND_REQUIRED = inspTypeDetail.is7A57RequiredValue;
          scheduleValue.value.IND_INTERVAL = inspTypeDetail.inspectionInterval;
          break;
        case "7":
          scheduleValue.value.OS_REQUIRED = inspTypeDetail.is7A57RequiredValue;
          scheduleValue.value.OS_INTERVAL = inspTypeDetail.inspectionInterval;
          break;
        case "8":
          scheduleValue.value.SERV_REQUIRED = inspTypeDetail.is7A57RequiredValue;
          scheduleValue.value.SERV_INTERVAL = inspTypeDetail.inspectionInterval;
          break;
        case "E":
          scheduleValue.value.ELEM_REQUIRED = inspTypeDetail.is7A57RequiredValue;
          scheduleValue.value.ELEM_INTERVAL = inspTypeDetail.inspectionInterval;
          break;
      }
    };

    //Update next Date value in the SNBI Inspection Types performed section
    const updateNextDate = (inspTypeDetail) => {
      //update insp type due date
      let snbiEvent = scheduleValue.value.SNBI_INSPECTION_TYPES?.find((t) => t.inspType === inspTypeDetail.inspType);
      if (snbiEvent) {
        snbiEvent.dueDate = inspTypeDetail.inspectionDueDate;
      }

      //instead of refreshing the entire inspections- updated the cloned insp used for display
      let clonedSnbiEvent = inspectionTypes.value.find((t) => t.inspType === inspTypeDetail.inspType);
      if (clonedSnbiEvent) {
        clonedSnbiEvent.dueDate = inspTypeDetail.inspectionDueDate;
      }

      //finally, update the scheduleValue object that feeds the page
      switch (inspTypeDetail.inspType) {
        case "2":
          scheduleValue.value.ROU_NEXT_DATE = inspTypeDetail.inspectionDueDate;
          break;
        case "3":
          scheduleValue.value.UW_NEXT_DATE = inspTypeDetail.inspectionDueDate;
          break;
        case "4":
          scheduleValue.value.NSTM_NEXT_DATE = inspTypeDetail.inspectionDueDate;
          break;
        case "6":
          scheduleValue.value.IND_NEXT_DATE = inspTypeDetail.inspectionDueDate;
          break;
        case "7":
          scheduleValue.value.OS_NEXT_DATE = inspTypeDetail.inspectionDueDate;
          break;
        case "8":
          scheduleValue.value.SERV_NEXT_DATE = inspTypeDetail.inspectionDueDate;
          break;
        case "E":
          scheduleValue.value.ELEM_NEXT_DATE = inspTypeDetail.inspectionDueDate;
          break;
      }
    };

    //Update next Date value in the SNBI Inspection Types performed section
    const updateFutureNextDate = (detail) => {
      switch (detail.inspType) {
        case "2":
          scheduleValue.value.ROU_NEXT_DATE = detail.dueDate;
          break;
        case "3":
          scheduleValue.value.UW_NEXT_DATE = detail.dueDate;
          break;
        case "4":
          scheduleValue.value.NSTM_NEXT_DATE = detail.dueDate;
          break;
        case "6":
          scheduleValue.value.IND_NEXT_DATE = detail.dueDate;
          break;
        case "7":
          scheduleValue.value.OS_NEXT_DATE = detail.dueDate;
          break;
        case "8":
          scheduleValue.value.SERV_NEXT_DATE = detail.dueDate;
          break;
        case "E":
          scheduleValue.value.ELEM_NEXT_DATE = detail.dueDate;
          break;
      }
    };
    const updateMaxEndDate = () => {
      const validDates = inspectionTypes.value
        .map((i) => (i.endDate ? new Date(i.endDate) : null))
        .filter((d) => d && !Number.isNaN(d));
      if (validDates.length === 0) {
        scheduleValue.value.OVERALL_END_DATE = null;
      } else {
        scheduleValue.value.OVERALL_END_DATE = new Date(Math.max(...validDates)).toISOString();
      }
    };
    const updateTeamLeader = () => {
      const selectedInspTypeArray = [];
      for (const type of inspectionTypes.value ?? []) {
        selectedInspTypeArray.push(inspTypeHierarchy.get(type.inspType));
      }
      //get the lowest rank element's inspType value
      const inspType = selectedInspTypeArray?.reduce(
        (prev, current) => (+prev?.rank < +current?.rank ? prev : current),
        null,
      )?.snbiInspType;

      scheduleValue.value.INSPUSRKEY = inspectionTypes.value.find((t) => t.inspType == inspType)?.teamLeader;
    };

    const allSnbiInspTypes = computed(() =>
      //Filter Z and Q types
      configStore.getReferenceValues(REFERENCE_TABLE.SNBI_INSPECTION_TYPE).filter((i) => !["Z", "Q"].includes(i.value)),
    );

    const getAvailableSnbiTypes = () => {
      const addedInspTypes = scheduleValue.value?.SNBI_INSPECTION_TYPES?.map((i) => i.inspType);
      //exclude already added inspTypes and show them as available
      return allSnbiInspTypes.value.filter((a) => !addedInspTypes?.includes(a.value));
    };

    const checkEquipmentValidations = (detail) => {
      // Atleast one of each type should be checked
      const selectedAccessEquipment = detail.selectedEquipment?.filter((e) => e.startsWith("A"));
      const selectedInspEquipment = detail.selectedEquipment?.filter((e) => e.startsWith("I"));
      if (selectedAccessEquipment?.length == 0 && selectedInspEquipment?.length == 0) {
        return {
          valid: false,
          message: ["At least one Access Equipment Required.", "At least one Inspection Equipment Required."],
        };
      } else if (selectedAccessEquipment?.length == 0) {
        return {
          valid: false,
          message: ["At least one Access Equipment Required."],
        };
      } else if (selectedInspEquipment?.length == 0) {
        return {
          valid: false,
          message: ["At least one Inspection Equipment Required."],
        };
      }
      //if "No Equip" is selected no other equip should be selected.
      if (selectedAccessEquipment?.includes("AN") && selectedAccessEquipment?.length > 1) {
        //show error
        return {
          valid: false,
          snackbarMessage: 'Unable to save - Access Equipment is checked with "No Acc. Equip. Used" also checked.',
          message: [],
        };
      }

      if (selectedInspEquipment?.includes("IN") && selectedInspEquipment?.length > 1) {
        //show error
        return {
          valid: false,
          snackbarMessage: 'Unable to save - Inspection Equipment is checked with "No Insp Equip Used" also checked.',
        };
      }

      return { valid: true, message: [] };
    };

    const updateEndDate = (detail) => {
      changesDetected.value = true;
      const startDate = detail.startDate ? new Date(detail.startDate) : null;
      const endDate = detail.endDate ? new Date(detail.endDate) : null;
      if (startDate > endDate) {
        detail.endDate = null;
      }
    };

    const validateEquipment = (detail) => {
      // limitation on the SNBI side - only 31 equipment can be selected.
      if (detail.equipConcat?.length > 120) {
        return {
          valid: false,
          snackbarMessage:
            "Unable to save - Too many pieces of equipment in use.  Please review the equipment selected.",
        };
      } else {
        return { valid: true };
      }
    };

    const updateInspectionArr = () => {
      let latestInspectionHeaderIndex = inspectionStore.getInspectionArray.findIndex(
        (i) => i.value == scheduleValue.value.INSPECTIONID,
      );
      let latestInspectionHeader = inspectionStore.getInspectionArray[latestInspectionHeaderIndex];
      latestInspectionHeader.title = `${getFormattedDateStringNoTime(
        scheduleValue.value.INSPDATE,
      )} - ${getStructureInspectionTypes(scheduleValue.value.INSPTYPE, getSnbiTypes(scheduleValue.value))}`;
      inspectionStore.getInspectionArray[latestInspectionHeaderIndex] = latestInspectionHeader;
    };

    const getStructureInspectionTypes = (primaryInspType, snbiInspTypes) => {
      if (snbiInspTypes?.length > 0) {
        return (
          " Type " +
          snbiInspTypes
            .map((e) => e)
            ?.sort()
            .join("")
        );
      } else {
        return configStore.getReferenceValue(REFERENCE_TABLE.INSPECTION_TYPE, primaryInspType);
      }
    };

    const getSnbiTypes = (scheduleValue) => {
      return scheduleValue.SNBI_INSPECTION_TYPES?.map((i) => i.inspType);
    };
    const setInspectorId = (detail) => {
      changesDetected.value = true;
      detail.inspectorId = configStore.getInspectorId(detail.teamLeader);
    };
    const setInspTypeDueDate = (detail) => {
      changesDetected.value = true;
      if (
        detail.isAdd &&
        detail.endDate &&
        detail.inspInterval > 0 &&
        !["Z", "1", "5", "9", "P", "Q"].includes(detail.inspType)
      ) {
        let endDateValue = new Date(detail.endDate);
        let day = endDateValue.getDate();
        const calculatedDueDate = new Date(endDateValue.setMonth(endDateValue.getMonth() + detail.inspInterval));
        if (calculatedDueDate.getDate() !== day) {
          //we crossed the month boundary
          calculatedDueDate.setDate(0); //set the last day of previous month
        }
        detail.dueDate = calculatedDueDate.toISOString();
      }
    };

    const toggleAllPanels = (expandAll) => {
      if (expandAll) {
        panel.value = allPanels;
      } else {
        panel.value = [];
      }
    };

    const commentsMaxLength = computed(() => {
      return configStore.getEnvConfigValue(ENV_CONFIG_PROPERTY.INSPECTION_COMMENT_MAX_LENGTH);
    });

    const checkIfError = () => {
      if (!scheduleValue.value || JSON.stringify(scheduleValue.value) == "{}") ctx.emit("showMessage");
    };

    const futureScheduleModuleType = computed(() => {
      return props.moduleType;
    });

    let brkey = ref("");
    let inspectionId = ref("");
    let resetDirty = ref(false);

    const readData = async () => {
      scheduleValue.value = {};
      brkey.value = "";
      inspectionId.value = "";
      futureScheduleTable?.value?.resetScheduleValue();
      inspectionTypes.value = [];
      resetDirty.value = true;
      if (props.moduleType == MODULE_TYPES.MANAGEMENT && structureHeader.value?.BRKEY) {
        if (!hasQuickSearchSucceeded.value) {
          resetDirty.value = true;
          return;
        }
        brkey.value = structureHeader.value.BRKEY;
        inspectionId.value = structureHeader.value.INSPECTIONID;
        await scheduleStore.loadDataObject(
          props.moduleType,
          structureHeader.value.BRKEY,
          structureHeader.value.INSPECTIONID,
          null,
        );
        scheduleValue.value = scheduleStore.getScheduleObject();
        checkIfError();
      } else if (props.moduleType == MODULE_TYPES.INSPECTION) {
        brkey.value = structure.value.structureBridge.brkey;
        inspectionId.value = structure.value.inspection.inspectionId;
        await scheduleStore.loadDataObject(props.moduleType, null, null, structure.value);
        scheduleValue.value = scheduleStore.getScheduleObject();
      }
      resetDirty.value = true;
      futureScheduleTable?.value?.setScheduleValue();
      getAllInspectionTypes();
      await validate();
    };

    const setUpdatedComment = (comment, commentType) => {
      const foundComment = scheduleValue.value.INSPECTION_COMMENTS.find((c) => {
        return c.commentType === commentType;
      });
      if (foundComment) {
        foundComment.notes = comment.notes;
        foundComment.updateUserId = comment.updateUserId;
        foundComment.updateDateTime = comment.updateDateTime;
      } else {
        scheduleValue.value.INSPECTION_COMMENTS.push(comment);
      }
    };

    const saveChanges = async () => {
      if (!valid.value) {
        inspectionStore.setShowValidationSnackbar(true);
      }
      inspectionStore.setShowValidationSnackbar(false);
      // Recalculate the next inspection type when saving
      recalcNextInspType();
      const structure = inspectionStore.selectedInspection;
      const isSuccess = await scheduleStore.saveData(
        props.moduleType,
        scheduleValue.value,
        structure,
        isAccepted.value,
      );
      if (isSuccess) {
        inspectionLinksStore.isDirty = false;
        await readData();
      }
      return isSuccess;
    };

    const recalcNextInspType = () => {
      const inspTypesMap = [
        { dateKey: "ROU_NEXT_DATE", inspType: "2" },
        { dateKey: "UW_NEXT_DATE", inspType: "3" },
        { dateKey: "NSTM_NEXT_DATE", inspType: "4" },
        { dateKey: "IND_NEXT_DATE", inspType: "6" },
        { dateKey: "OS_NEXT_DATE", inspType: "7" },
        { dateKey: "SERV_NEXT_DATE", inspType: "8" },
        { dateKey: "ELEM_NEXT_DATE", inspType: "E" },
      ];

      const arrayForRecalc = inspTypesMap.map(({ dateKey, inspType }) => ({
        inspectionDueDate: scheduleValue.value[dateKey],
        inspType,
      }));
      scheduleValue.value.NEXT_INSP_TYPE = calculateNextInspType(arrayForRecalc);
    };

    const cancelChanges = async () => {
      //only called from Inspection Links
      scheduleValue.value = scheduleStore.getScheduleObject();
      futureScheduleTable?.value?.setScheduleValue();
      // Using this flag to not set the dirty flag in watch
      resetDirty.value = true;
      getAllInspectionTypes();

      // Revalidate the forms with the unmodified data
      await modifyInspectionScheduleForm.value.validate();
      await futureScheduleTable?.value?.validateForm();
      validationSnackbar.value = false;
      inspectionLinksStore.isDirty = false;
    };

    const setAddingOrEditingValue = (value) => {
      if (props.moduleType == MODULE_TYPES.MANAGEMENT) {
        inspectionLinksStore.isAddingOrEditingSchedule = value;
      } else {
        inspectionStore.setAddingOrEditing(value);
      }
    };
    const hasAccessToEditExtendedInspectionIntervalConcurrence = computed(() =>
      userPermissionStore.checkUserPermission(
        INSPECTION_LINKS_SCHEDULE_PERMISSIONS.editExtendedInspectionIntervalConcurrence,
        userPermissionStore.getUserPermissionByBrkeyFromCache(scheduleValue.value.BRKEY),
      ),
    );

    const hasAccesstoEditSnbiInspectionTypes = computed(() =>
      userPermissionStore.checkUserPermission(
        INSPECTION_LINKS_SCHEDULE_PERMISSIONS.editSnbiInspectionTypes,
        userPermissionStore.getUserPermissionByBrkeyFromCache(scheduleValue.value.BRKEY),
      ),
    );

    onMounted(async () => {
      await readData();
    });

    const printD491 = () => {
      return { reportPage: "D491-Insp-Schedule-Screen", marker: SNACKBAR_MARKER.SCHEDULE };
    };

    watch(
      () => [props],
      () => {
        readData();
      },
      { deep: true },
    );

    // watch those objects used in component from structure to warn about unsaved changes
    watch(
      () => [scheduleValue],
      () => {
        // This watch will NOT be triggered during initial onMounted()
        if (props.moduleType === MODULE_TYPES.MANAGEMENT) {
          // for management module
          if (resetDirty.value) {
            inspectionLinksStore.isDirty = false;
            resetDirty.value = false;
          } else {
            inspectionLinksStore.isDirty = true;
          }
        } else if (props.moduleType === MODULE_TYPES.INSPECTION) {
          // for inspection  module
          if (resetDirty.value) {
            inspectionStore.setDirtyFlag(false);
            resetDirty.value = false;
          } else {
            inspectionStore.setDirtyFlag(true);
          }
        }
      },
      { deep: true },
    );

    watch(
      expandedRows,
      (newValue) => {
        if (newValue?.length == 0) {
          snackbarStore.removeMessage(snackBarId.value);
        }
      },
      { immediate: true },
    );

    return {
      updateLegacySchedule,
      underwaterDivers,
      INSPECTION_TYPE_PERFORMED,
      getTeamLeaders,
      ROUNDING_FACTOR,
      updateInspectionOrganization,
      helperHrs,
      nstmHrs,
      craneHrs,
      crewHrs,
      hasAccessToEditExtendedInspectionIntervalConcurrence,
      hasAccesstoEditSnbiInspectionTypes,
      isAccepted,
      panel,
      tableData,
      structure,
      isEditable,
      valid,
      validate,
      modifyInspectionScheduleForm,
      requiredRule,
      REFERENCE_TABLE,
      valueInRangeRule,
      anyEditable,
      addInspType,
      expandedRows,
      inspTypeHeaders,
      inspectionTypes,
      sortBy,
      rowClass,
      toggleRow,
      isExpanded,
      editInspType,
      deleteInspType,
      saveInspType,
      closeInspType,
      getFormattedDateStringNoTime,
      validDetails,
      inspTypeDetailForm,
      changesDetected,
      configStore,
      accessEquipment,
      inspectionEquipment,
      updateEquipment,
      closeConfirm,
      BUTTONS,
      INSPECTION_MESSAGES,
      inspectionStore,
      setInspTypeFieldDependencies,
      updateInterval,
      getAvailableSnbiTypes,
      equipmentError,
      updateFieldDependencies,
      futureScheduleTable,
      isValidInspTypes,
      getAllInspectionTypes,
      updateEndDate,
      setInspectorId,
      updateInspectionArr,
      updateNextDate,
      setInspTypeDueDate,
      toggleAllPanels,
      INSPECTION_COMMENTS,
      MODULE_TYPES,
      commentsMaxLength,
      readData,
      futureScheduleModuleType,
      scheduleValue,
      setUpdatedComment,
      saveChanges,
      cancelChanges,
      printD491,
      schedulePageValid,
      showExtendedIntervalAuditTooltips,
    };
  },
  components: {
    LabelCheckbox,
    LabelText,
    LabelSelect,
    LabelDatefield,
    DataTableHeader,
    IconTooltip,
    ConfirmDialog,
    FutureScheduleTable,
    ExpandCollapseToggle,
    CommentTypeTextField,
    ManagementCommentTypeTextField,
    ValidationCountsHeader,
  },
});
</script>

<style scoped lang="scss">
@use "@/styles/colors" as c;

.v-expansion-panel-title,
.v-expansion-panel-title:hover {
  background-color: c.$p-pa-light-blue !important;
}

h3 {
  order: 1;
  color: c.$p-white !important;
}

.v-expansion-panel-title__icon {
  order: 0;
}

button:focus {
  outline: none !important;
}

.label-radio-btn {
  position: relative !important;
}

.v-input {
  flex: none !important;
  opacity: 1 !important;
}

td {
  white-space: nowrap;
}

.compactTable th,
.compactTable td {
  padding: 0 0.25rem !important;
}

.col-7A09 :deep(.v-input__details) {
  padding-right: 0 !important;
  padding-left: 0 !important;
  text-align: center !important;
  white-space: normal !important;
}

.compactTable th {
  vertical-align: baseline !important;
  text-align: center !important;
}

.col-7A07 :deep(.v-input__control) {
  margin: 0 auto !important;
  display: inline-block !important;
}

.sub-section-header {
  background-color: c.$p-pa-light-blue;
  color: c.$p-white;
  font-weight: 600;
}
td.align-center :deep(.v-row) {
  justify-content: center;
}
.alignCenter {
  text-align: center;
}

.wrapValue :deep(span) {
  width: 100%;
  white-space: normal;
  word-wrap: break-word;
}
.equipTable :deep(.v-label) {
  font-size: 0.71rem;
  display: flex !important;
  align-items: center;
}
.morePaddingTableColumns {
  th,
  td {
    padding-top: 6px !important;
    padding-bottom: 6px !important;
    padding-left: 6px !important;
    padding-right: 6px !important;
  }
}
</style>
